import { render, staticRenderFns } from "./DesmatamentoVegaComSojaVegaParaguai.vue?vue&type=template&id=70b5bd4e&lang=pug"
import script from "./DesmatamentoVegaComSojaVegaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoVegaComSojaVegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports